import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import {
  deliveryReport,
  DeliveryReportSortField,
  DeliveryReportUrlQueryParams
} from "./urls";
import DeliveryReport from "./views/DeliveryReport";

const DeliveryReportMain = () => {
  const intl = useIntl();

  const DeliveryReportPage: React.FC<RouteComponentProps<any>> = ({
    location
  }) => {
    const qs = parseQs(location.search.substr(1));
    const params: DeliveryReportUrlQueryParams = asSortParams(
      qs,
      DeliveryReportSortField,
      DeliveryReportSortField.dnNo,
      true
    );
    return <DeliveryReport params={params} />;
  };

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.inquiry3Admin)} />
      <Switch>
        <Route exact path={deliveryReport} render={DeliveryReportPage} />
      </Switch>
    </>
  );
};

export default DeliveryReportMain;
